import axios from "axios";
import { DonationsModel } from "../../pages/donations/models/DonationsModel";
const API_URL = process.env.REACT_APP_API;

export async function getAllDonations() {
  const response = await axios.get(`${API_URL}donativos`);
  const data = response.data.doc.data;
  return data;
}

export async function createNewDonations(body: DonationsModel) {
  try {
    const response = await axios.post(`${API_URL}donativos`, body);
    const data = response.data.doc.data;
    return data;
  } catch (err) {
    console.error("Error al registrar la compra o donativo:", err);
    throw err;
  }

}

export async function insertSubAccount(SubName: string, id: string) {
  const response = await axios.post(`${API_URL}catalogos/subcuentas/add`, {
    nombre: SubName,
    cuenta_id: id,
  });
  return response;
}


export async function actualizarPrecioService(id: number, costo_sugerido: number) {
  try {
    const response = await axios.patch(`${API_URL}/producto/${id}`, {
      costo_sugerido: costo_sugerido,
    });
    const data = response.data;
    return data;
  } catch (err) {
    console.error("Error al actualizar el precio:", err);
    throw err;
  }

}

export async function getDetailDonations(id: number) {
  try {
    const response = await axios.get(`${API_URL}donativos/detalle/producto/${id}`);
    const data = response.data.doc.data;
    return data;
  } catch (err) {
    console.error("Error al actualizar el precio:", err);
    throw err;
  }

}
